import {axiosCatchHandler} from "../sharedGlobal";

const SET_PLAN = 'SET_PLAN';
const SET_MODAL_OPEN = 'SET_MODAL_OPEN';
const SET_PLAN_ID = 'SET_PLAN_ID';
const SET_GENERATING_POLL_COUNT = 'SET_GENERATING_POLL_COUNT';
const SET_STARTING_GENERATION = 'SET_STARTING_GENERATION';

const state = {
  modalOpen: false,
  planId: null,
  plan: null,
  startingGeneration: false,
  generatingPollCount: 0,
};

const getters = {
  modalOpen: ({ modalOpen }) => modalOpen,
  planId: ({ planId }) => planId,
  plan: ({ plan }) => plan,
  startingGeneration: ({ startingGeneration }) => startingGeneration,
  generating: ({ plan }) => plan?.generating_status === 'pending',
  generatingFailed: ({ generatingPollCount, plan }) =>
    (generatingPollCount === 125 && plan?.generating_status !== 'completed')
    || plan?.generating_status === 'failed',
};

const actions = {
  async openModal({ commit }, { planId }) {
    await commit(SET_MODAL_OPEN, true);
    await commit(SET_PLAN_ID, planId);
  },
  closeModal({ commit }) {
    commit(SET_PLAN, null);
    commit(SET_PLAN_ID, null);
    commit(SET_GENERATING_POLL_COUNT, 0);
    commit(SET_STARTING_GENERATION, false);
    commit(SET_MODAL_OPEN, false);
  },
  async getPlan({ commit, state }) {
    try {
      const { data } = await axios.get(`/ajax/gpt3/blogwizard/${state.planId}`);
      await commit(SET_PLAN, data.plan);
    } catch(e) {
      axiosCatchHandler(e)
    }
  },
  async startGenerating({ commit, dispatch, state }) {
    try {
      await commit(SET_STARTING_GENERATION, true);
      const { data } = await axios.post(`/ajax/gpt3/blogwizard/${state.planId}`);
      await commit(SET_PLAN, data.plan);
      await commit(SET_GENERATING_POLL_COUNT, 0);
      await commit(SET_STARTING_GENERATION, false);
      dispatch('pollGeneration');
    } catch(e) {
      axiosCatchHandler(e)
      await commit(SET_STARTING_GENERATION, false);
    }
  },
  async pollGeneration({ commit, dispatch, state }) {
    if (
      state.generatingPollCount >= 125 ||
      state.plan?.generating_status !== 'pending'
    ) {
      return;
    }

    commit(SET_GENERATING_POLL_COUNT, state.generatingPollCount + 1);

    await dispatch('getPlan');

    await new Promise(resolve => setTimeout(resolve, 5000)); // Wait 5 seconds between poll requests

    return dispatch('pollGeneration');
  }
};

const mutations = {
  [SET_MODAL_OPEN](state, open) {
    state.modalOpen = open;
  },
  [SET_PLAN_ID](state, planId) {
    state.planId = planId;
  },
  [SET_PLAN](state, plan) {
    state.plan = plan;
  },
  [SET_STARTING_GENERATION](state, starting) {
    state.startingGeneration = starting;
  },
  [SET_GENERATING_POLL_COUNT](state, count) {
    state.generatingPollCount = count;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
